import {httpClient} from '../baseApi';

export async function requestCoolantData(machineId: string, startDate: number, endDate: number) {
  const {data} = await httpClient.get(`services/coolant/get_data/`, {
    params: {
      machine_id: machineId,
      start_date: startDate,
      end_date: endDate,
      points_to_keep: 1000,
    },
  });

  const series = data.coolant_flowmeter_mean.map((elem: {timestamp: number; data: any}): {
    x: number;
    y: number;
  } => ({
    x: elem.timestamp,
    y: elem.data['mean'],
  }));

  const intervalsModes = data.machine_status_events.map((elem: any) => ({
    from: elem.start,
    to: elem.end,
    mode: elem.unstatus,
  }));

  return {
    series,
    intervalsModes,
  };
}
